export var cookieUtil = {
    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        if (exdays != 0) {
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
        }

        window.$.cookie(cname, cvalue, {path: '/', expires: d});
    },

    getCookie(cname) {
        if (cname) {
            if (window.$.cookie(cname)) {
                return window.$.cookie(cname);
            } else {
                return '';
            }
        }
    },

    deleteCookie(cname) {
        window.$.removeCookie(cname, {path: '/'});
    }
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/cookie-util.js
// module id = 15
// module chunks = 0